export enum TournamentStatus {
    ANNOUNCEMENT = 'ANNOUNCEMENT',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
}